import { useEffect, useState, useCallback } from "react";
import { AxiosResponse } from "axios";
import { useInstanceValue } from "app/hooks/useInstanceValue";

type SingleEntityData = {
  id?: number;
};

function useFetchData<T, P = SingleEntityData, O = any>(
  call: (...params) => Promise<AxiosResponse<T>>,
  config: {
    params?: P;
    options?: O;
    shouldCallApi?: boolean;
  }
) {
  const [data, setData] = useState<T>();
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  const { params, options, shouldCallApi = true } = config;

  const fetchDataRef = useInstanceValue(async () => {
    try {
      setLoading(true);
      setIsError(false);

      const response = await call(params, options);
      setData(response.data);
      setIsSuccess(true);
    } catch {
      setIsError(true);
    } finally {
      setLoading(false);
    }
  });

  const paramsStr = JSON.stringify(params);
  const optionsStr = JSON.stringify(options);

  useEffect(() => {
    paramsStr?.toString();
    optionsStr?.toString();
    shouldCallApi && fetchDataRef.current();
  }, [fetchDataRef, optionsStr, paramsStr, shouldCallApi]);

  const refetch = useCallback(() => {
    paramsStr?.toString();
    optionsStr?.toString();
    shouldCallApi && fetchDataRef.current();
  }, [paramsStr, optionsStr, shouldCallApi, fetchDataRef]);

  return { data, loading, isError, isSuccess, refetch };
}

export default useFetchData;
